import LegalDocument from './legal/LegalDocument'
import refundPolicy from './legal/content/refundPolicy'

/**
 * Refund and cancellation policy — a short page Stripe's reviewers look for.
 * It restates sections 12, 13 and 15 of the Terms; keep the two in sync.
 *
 * URL: https://ovacs.com/refund-policy
 */
const RefundPolicyPage = () => (
  <LegalDocument
    doc={refundPolicy}
    description="How cancelling and refunds work for OVACS subscriptions."
  />
)

export default RefundPolicyPage
